export default "__VITE_ASSET__d5b5e915__"